import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ibdc-ibd-angular-components',
  template: `
    <p>
      ibd-angular-components works!
    </p>
  `,
  styles: [
  ]
})
export class IbdAngularComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
